module.exports = __webpack_public_path__ + "f2ffaf0c70b399383dfa1b77bb8c632b.png";